import { Component, OnInit } from '@angular/core';
import { BaseModalContainer, ModalContainerService, ModalService, UserService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';
import { Mesto } from './mesto';
// import { NotifierService } from 'angular-notifier';

@Component({
  selector: 'app-mesto',
  templateUrl: './mesto.component.html'
})
export class MestoComponent extends BaseModalContainer<Mesto> implements OnInit {
  constructor(
    protected modalContainerService: ModalContainerService<Mesto>,
    protected activatedRoute: ActivatedRoute,
    protected modalService: ModalService,
    protected userService: UserService
    //protected notifierService: NotifierService
  ) {
    super(modalContainerService, activatedRoute, modalService, userService);
  }

  ngOnInit() {
    //this.notifierService.notify('success', '234234233');
  }

}
